import { useState, useRef } from 'react';
import Footer from './Footer.js';
import MainContent from '../MainContent.jsx';
import Summary from '../Summary.jsx';

export default function Layout()
{

    const runningInDev = process.env.NODE_ENV === 'development' ? true : false;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // need this to swap between rendering main content and summary component via continue/back buttons in maincontent/summary components
    // could mess with adding query params on those button clicks, and checking them as would be checked on first load,...
    // ...but need this variable is needed to trigger re-render anyway so may as well just hold bool value in it
    const [showSummaryOverride, setShowSummaryOverride] = useState(null);
    const [removeFromBasket, setRemoveFromBasket] = useState(null);
    const [removeFromBasketBuildID, setRemoveFromBasketBuildID] = useState(null);

    const summarySelectionRef = useRef(null);
    const imageLoaded = useRef(false);

    let viewMode = false;
    let showSummary = false;
    let isTest = false;
    if (showSummaryOverride !== null)
    {
        showSummary = showSummaryOverride;
    }
    else
    {
        for (const key of urlParams.keys()) 
        {
            if (key === "showsummary")
            {
                showSummary = true;
            }
            else if (key === "istest")
            {
                isTest = true;
            }
        }
    }

    for (const key of urlParams.keys()) 
    {

        if (key === "istest")
        {
            isTest = true;
        }
        if (key === "view")
        {
            viewMode = true;
            showSummary = true;
        }

    }

    // this will run before full component re-render
    const handleToggleSummary = (showSummary, removeFromBasket, removeFromBasketBuildID) =>
    {
        const queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);

        if (showSummary)
        {
            urlParams.set("showsummary", true);
        }
        else
        {
            urlParams.delete("showsummary");
            urlParams.delete("view");
        }

        window.history.replaceState(null, null, window.location.pathname + "?" + urlParams.toString());

        setRemoveFromBasket(removeFromBasket);
        setRemoveFromBasketBuildID(removeFromBasketBuildID);
        setShowSummaryOverride(showSummary);

        // add page to history to cater for users hitting back button to go back to change options
        window.history.pushState({ modalOpen: true }, '');
    }

    return (
        <div className="mx-auto">

            {
                runningInDev && <div className="header-messages-container bg-warning text-center text-dark"><small>You are running this application in <b>{process.env.NODE_ENV}</b> mode.</small></div>
            }

            {
                    showSummary
                        ?
                        <Summary handleToggleSummary={handleToggleSummary} removeFromBasket={removeFromBasket} removeFromBasketBuildID={removeFromBasketBuildID} categoryItem={summarySelectionRef} imageLoaded={imageLoaded} isTest={isTest} viewMode={viewMode} />
                        :
                        <MainContent handleToggleSummary={handleToggleSummary} categoryItem={summarySelectionRef} imageLoaded={imageLoaded} />
            }

            { /* Footer */}
            <Footer />

        </div>
    );

}